import { React, PT, withRouter } from '@gasbuddy/react';
import moment from 'moment';
import { Table } from 'semantic-ui-react';

const BaseTagTable = ({ tags }) => (
  <Table basic="very" selectable style={{ tableLayout: 'fixed', fontSize: '0.9em' }}>
    <Table.Header>
      <Table.Row>
        <Table.HeaderCell width={2}>Created</Table.HeaderCell>
        <Table.HeaderCell width={2}>Last Updated</Table.HeaderCell>
        <Table.HeaderCell width={3}>Type</Table.HeaderCell>
        <Table.HeaderCell>Value</Table.HeaderCell>
      </Table.Row>
    </Table.Header>
    <Table.Body>
      {tags.map(tag => (
        <Table.Row key={tag.value}>
          <Table.Cell>{moment(tag.created_at).format('M/DD/YY HH:mm')}</Table.Cell>
          <Table.Cell>{moment(tag.updated_at).format('M/DD/YY HH:mm')}</Table.Cell>
          <Table.Cell>{tag.type}</Table.Cell>
          <Table.Cell>
            {tag.value ? tag.value : 'n/a'}
          </Table.Cell>
        </Table.Row>
      ))}
    </Table.Body>
  </Table>
);

BaseTagTable.propTypes = {
  tags: PT.arrayOf(PT.shape({
    created_at: PT.string,
    type: PT.string,
    updated_at: PT.string,
    value: PT.string,
  })),
};

BaseTagTable.defaultProps = {
  tags: [],
};

export const TagTable = withRouter(BaseTagTable);
